<template>
  <div>
    <div class="bannner-box">
      <div class="wrap">
        <h1>关于我们</h1>
        <h2></h2>
        <p>
          辰时微光，心如沐阳<br />
          辰微沐阳护您心灵无恙
        </p>
      </div>
    </div>
    <img src="../assets/mobile-imgs/about-title.png" class="mobile" />
    <div class="hack wrap">
      <img src="../assets/imgs/about-img.png" alt="" />
      <div>
        <h2>关于我们</h2>
        <p>
          致力打造“互联网+智慧心理体系建设”闭环式服务模式为基础；以“智慧化、按需定制”为核心竞争力；以服务为基础，以技术为导向，以运维为根本，以智慧化为发展，立足于智慧化生态体系云平台；全力打造智慧医疗心理服务体系建设等整体解决方案、智慧校园心理服务体系建设、EAP心理服务。
        </p>
      </div>
    </div>
    <div class="map">
      <h1>联系我们</h1>
      <div class="wrap">
        <ul>
          <li>
            <img src="../assets/imgs/about-company.png" alt="" />
            四川辰微沐阳心理咨询有限公司
          </li>
          <li>
            <img src="../assets/imgs/about-phone.png" alt="" />
            联系电话：赵先生 15982263185
          </li>
          <li>
            <img src="../assets/imgs/about-phone.png" alt="" />
            联系电话：刘先生 15982263185
          </li>
        </ul>
        <baidu-map
          id="map"
          ak="ocjtpCpd3HusX9VUmkfc49P9jxRV5Vch"
          :center="{ lng: 104.07231, lat: 30.663467 }"
          :zoom="12"
          :scroll-wheel-zoom="true"
        >
          <bm-marker :position="{ lng: 104.07231, lat: 30.663467 }" />
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
import { BaiduMap, BmMarker } from "vue-baidu-map";
export default {
  components: { BaiduMap, BmMarker },
};
</script>

<style lang="less" scoped>
.bannner-box {
  width: 100%;
  background: url("../assets/imgs/about-banner.png") no-repeat;
  background-size: 100% 100%;
  .wrap {
    padding-left: 93px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 400px;
    color: #ffffff;
    h1 {
      font-size: 47px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    h2 {
      margin: 28px 0;
      width: 58px;
      height: 7px;
      background: #ffffff;
    }
    p {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 55px;
    }
  }
}
.hack {
  padding: 50px 0;
  display: flex;
  align-items: center;
  & > * {
    flex: 1;
  }
  div {
    height: 360px;
    padding: 38px 42px;
    box-sizing: border-box;
    background: url("../assets/imgs/about-bg.png") no-repeat;
    background-size: 100% 100%;
    margin-left: -30px;
    h2 {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #42aab2;
      margin-bottom: 30px;
    }
    p {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #909090;
      line-height: 36px;
    }
  }
}
.map {
  height: 336px;
  background: url("../assets/imgs/about-map-bg.png") no-repeat;
  background-size: cover;
  margin-bottom: 50px;
  padding: 34px 0;
  box-sizing: border-box;
  h1 {
    text-align: center;
    letter-spacing: 3px;
    font-size: 27px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #282828;
    margin-bottom: 28px;
  }
  .wrap {
    display: flex;
    justify-content: center;
    ul {
      padding-top: 24px;
    }
    li {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #282828;
      margin-bottom: 25px;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    #map {
      width: 400px;
      height: 200px;
      margin-left: 124px;
    }
  }
}
@media (max-width: 760px) {
  .bannner-box {
    height: 2.5rem;
    padding: 0.45rem 0.65rem;
    box-sizing: border-box;
    .wrap {
      padding: 0;
      height: unset;
      h1 {
        font-size: 0.36rem;
        margin-bottom: 0.15rem;
      }
      h2 {
        display: none;
      }
      p {
        font-size: 0.2rem;
        line-height: 0.55rem;
      }
    }
  }
  img.mobile {
    height: 0.47rem;
    margin: 0.2rem auto;
    display: block;
  }
  .hack {
    display: block;
    padding: 0 0.25rem;
    box-sizing: border-box;
    img {
      width: 100%;
    }
    div {
      background: unset;
      padding: 0rem 0.08rem;
      margin-left: 0;
      height: unset;
      h2 {
        display: none;
      }
      p {
        font-size: 0.2rem;
        line-height: 0.36rem;
      }
    }
  }
  .map {
    height: unset;
    margin-top: 0.3rem;
    padding-top: 0.22rem;
    background-size: 100% 100%;
    padding-bottom: 0;
    h1 {
      font-size: 0.2rem;
    }
    .wrap {
      align-items: center;
      display: block;

      #map {
        width: 100%;
        height: 4rem;
        margin-left: 0;
      }
      ul {
        padding: 0 0.2rem;
        padding-top: 0.16rem;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        li {
          font-size: 0.2rem;
          margin-bottom: 0.3rem;
          text-align: center;
          max-width: 49%;
          img {
            height: 0.18rem;
            margin-right: 0.1rem;
          }
        }
      }
    }
  }
}
</style>
